Vue.filter('intToCurrency', function (value, currency = 'GBP', decimals = 2) {
    return Number(value).toLocaleString('en-GB', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: decimals
    });
});